// removed by extract-text-webpack-plugin
module.exports = {"showMobile":"_1wAmUaLFd4IqQyUZh-GyVT","container":"JH9R_qxLJW550Zq4lc6um","menu":"_1ZNxSxZAJcUY5LkjjcM-w2","head":"_1d_-GPhz35_pGesXw0FtV6","navigation":"_3OQq7fL1BbchbjIFdbpeUH","item":"_3OKRSwS0lQrAYIHt_Se2Bl","active":"_3dPdYuWtwu708_OU-7Upq2","logOut":"_2WamLm8a-W3H1S0UkInB-0","menuMobile":"_1s8tGvOeVATc1lI5CpJpPe","content":"_39E0rRJ2hOAAKsNkwatzoF","login":"_9yCDmFBqnq0sZ1SfH5gD8","spinner":"rYXe3KlWCK0Vk1FXezo_l","menuItem":"i24HODYOLkmkcvCy_ToGY","menuHeader":"_3h-CBmp9xlAz4xDC5PWd-f"};


//////////////////
// WEBPACK FOOTER
// ./app/components/AppFrame/style.scss
// module id = 1069
// module chunks = 0